// extracted by mini-css-extract-plugin
export var alignBaseline = "flexbox-module--alignBaseline--45f14";
export var alignCenter = "flexbox-module--alignCenter--077e6";
export var alignEnd = "flexbox-module--alignEnd--4d9f9";
export var alignStart = "flexbox-module--alignStart--73ce3";
export var alignStretch = "flexbox-module--alignStretch--7e22b";
export var gapBase = "flexbox-module--gapBase--b96ab";
export var gapLarge = "flexbox-module--gapLarge--099a0";
export var gapLargest = "flexbox-module--gapLargest--dcf99";
export var gapMedium = "flexbox-module--gapMedium--52db8";
export var gapNone = "flexbox-module--gapNone--d3b06";
export var gapSmall = "flexbox-module--gapSmall--fd66f";
export var gapSmallest = "flexbox-module--gapSmallest--f02e5";
export var gapTiny = "flexbox-module--gapTiny--4de04";
export var gapXl = "flexbox-module--gapXl--d5124";
export var gapXs = "flexbox-module--gapXs--4c2a2";
export var gapXxl = "flexbox-module--gapXxl--3eb47";
export var gapXxs = "flexbox-module--gapXxs--1dfa7";
export var justifyAround = "flexbox-module--justifyAround--983c8";
export var justifyBetween = "flexbox-module--justifyBetween--f8040";
export var justifyCenter = "flexbox-module--justifyCenter--17df6";
export var justifyEnd = "flexbox-module--justifyEnd--7d122";
export var justifyEvenly = "flexbox-module--justifyEvenly--8966b";
export var justifyStart = "flexbox-module--justifyStart--62d36";
export var justifyStretch = "flexbox-module--justifyStretch--b19a9";